import axios from "axios";
import {
  cacheAdapterEnhancer,
  throttleAdapterEnhancer
} from "axios-extensions";

const files = {
  urls: {
    stage: process.env.VUE_APP_STAGE_FILES_URL,
    prod: process.env.VUE_APP_PROD_FILES_URL
  },
  _axios: null,
  authToken: null,

  init() {
    this.updateAxiosInstance();
  },

  async axios() {
    await this._updateAxiosInstance();
    return this._axios;
  },

  updateAxiosInstance(user) {
    this.user = user;
    return this._updateAxiosInstance();
  },

  async _updateAxiosInstance() {
    const newToken = this.user && (await this.user.getIdToken());
    if (this.authToken === newToken) {
      return;
    }
    this.authToken = newToken;
    this._axios = axios.create({
      headers: {
        authorization: this.authToken ? `Bearer ${this.authToken}` : undefined
      },
      adapter: throttleAdapterEnhancer(
        cacheAdapterEnhancer(axios.defaults.adapter)
      )
    });
  },

  async getImage(imageKey, isProd) {
    const axios = await this.axios();
    const url = `${isProd ? this.urls.prod : this.urls.stage}/${imageKey}`;
    console.log(url);
    return (await axios.get(url, { responseType: "blob" })).data;
  }
};

export default files;
